// -------------------------------------
// #SLICK
// -------------------------------------

jQuery(document).ready(function ($) {
    function debounce(func, wait) {
        var timer = null;
        return function () {
            clearTimeout(timer);
            timer = setTimeout(func, wait);
        };
    }

    var prevArrow = '<svg viewBox="0 0 24 24" class="slick-prev"><use href="#slider-arrow"/></svg>';
    var nextArrow = '<svg viewBox="0 0 24 24" class="slick-next"><use href="#slider-arrow"/></svg>';

    $("#slick-banner-home").on('init', function(event, slick){        
        setTimeout(function () {
            $('#slick-banner-home').addClass('slick-animation-start');
        }, 500);
    });

    $("#slick-banner-home").slick({
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        swipeToSlide: true,
        lazyLoad: "progressive",
        asNavFor: '#slick-banner-navbar',
    });

    $("#slick-banner-navbar").slick({
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 0,
        appendArrows: $('#banner-navbar-arrows'),
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        swipeToSlide: true,
        asNavFor: '#slick-banner-home',
    });

    $("#slick-space").slick({
        infinite: false,
        appendArrows: $('#space-arrows'),
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        swipeToSlide: true,
        slidesToShow: 3,
        lazyLoad: "progressive",
        responsive: [
            {
            breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
            breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                }
            },
        ]
    });

    $(".space-list .item-slider, .space-slider .item-slider").slick({
        arrows: true,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        dots: true,
        draggable: false,
        swipe: false,
        lazyLoad: "progressive",
    });

    $("#slick-showcase").on('init', function(event, slick){        
        setTimeout(function () {
            $('#slick-showcase').addClass('slick-animation-start');
        }, 500);
    });

    $("#slick-showcase").slick({
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        swipeToSlide: true,
        lazyLoad: "progressive",
        asNavFor: '#slick-showcase-navbar',
    });

    var showcaseNavbar = $('#slick-showcase-navbar');

    showcaseNavbar.on('init', function(event, slick){
        var showcaseNavbarHeight = showcaseNavbar.outerHeight();
        document.documentElement.style.setProperty('--showcase-navbar-height', "".concat(showcaseNavbarHeight, "px"));

        window.addEventListener('resize', debounce(function(){
            showcaseNavbarHeight = showcaseNavbar.outerHeight();
            document.documentElement.style.setProperty('--showcase-navbar-height', "".concat(showcaseNavbarHeight, "px"));
        }, 100));
    });

    showcaseNavbar.slick({
        infinite: true,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        swipeToSlide: true,
        slidesToShow: showcaseNavbar.data('slides') < 5 ? showcaseNavbar.data('slides') : 5,
        focusOnSelect: true,
        lazyLoad: "progressive",
        asNavFor: '#slick-showcase',
        responsive: [
            {
            breakpoint: 1024,
                settings: {
                    slidesToShow: showcaseNavbar.data('slides') < 4 ? showcaseNavbar.data('slides') : 4,
                }
            },
            {
            breakpoint: 640,
                settings: {
                    centerMode: true,
                    centerPadding: 0,
                    slidesToShow: showcaseNavbar.data('slides') < 3 ? showcaseNavbar.data('slides') : 3,                    
                }
            },
            {
                breakpoint: 480,
                    settings: {
                        slidesToShow: 3,                    
                    }
                },
        ]
    });

    $('#slick-space .item-slider-img, .space-item .item-slider-img').click(function() {
        var linkElement = $(this).parents('.item-style').find('a');
        if (linkElement.length) {
            linkElement[0].click();
        }
    });
});
